import { Directive } from '@angular/core';

@Directive({
  selector: '[qpointTabNavDetailTemplate]',
  standalone: true
})
export class QPointTabNavDetailTemplateDirective {}
